<template>
  <div class="text-style">
    <b class="text-6xl self-start md:self-center">{{ props.number }}</b>
    <p class="text-base md:text-center font-bold">{{ props.text }}</p>
  </div>
</template>
<script setup lang="ts">
const props = defineProps({
  number: {
    type: Number,
    required: true,
  },
  text: {
    type: String,
    required: true,
  },
});
</script>
<style scoped>
.text-style {
  @apply text-primary flex flex-col font-bold text-5xl w-auto md:w-25 max-w-[140px] py-8 md:mx-auto text-left justify-start md:justify-center md:flex;
  font: normal normal 600 18px Open Sans;
  opacity: 1;
}
.text-style:last-child {
  @apply col-span-2 mx-auto;
}
</style>
